<template>
<!-- 重要字段的使用说明：
this.type 是判断群还是私聊
$store.state.group.jobInfo  
cPageItem  当前聊天对象的信息 -->
 <!-- v-if="Object.keys(selectMess).length" -->
  
    <el-container class="messagebox" v-if="Object.keys(cPageItem).length && userList[type].length"> 
      <!-- selectMess = {{selectMess}}  type = {{type}}   ---- {{$data.activedKey[type].FriendNickName}} -->
      <!-- <h3>cPageType = {{cPageType}} ==--  {{cPageItem}}</h3> -->
        <!-- 页面布局：一：顶部  具体聊天对象的信息 查看其他信息的按钮 -->
        <el-header class="messagebox-header">
            <span class="name">{{cPageItem.NickName || resetName(cPageItem.name) || ''}}</span>
            <!-- <button v-if="type == 'contact' && !hasService" class="btn-primary">选为中标人</button> -->
            <!-- <button v-if="type == 'contact' && !hasService"  class="btn-primary" @click="takeCall">电话沟通</button>
            <button v-if="type == 'contact' && !hasService" class="btn-primary" @click="lookOffer">查看报价</button>
            <button v-if="type == 'contact' && !hasService" class="btn-primary" @click="lookResume">查看简历</button> -->
            <!-- 前台的项目 不需要修改群名称 -->
            <el-button  v-if="type == 'group'  && !hasService" type="text" @click="changGroupInfoFun">修改群名</el-button>
        </el-header>
        <el-container>
            <el-main class="messagebox-main" >
                <!-- 页面布局：二：center中间  聊天记录区 -->
                <div class="messagebox-content" ref="msgContent" v-if="true">
                    <div class="more-msgs" @click="loadMoreMsgs">{{loadText}}</div>
                    <div v-for="(item,i) in msgList" :key="i" :class="['message-group',{self:item.bySelf}]">
                        <!-- 头像 -->
                        <div class="owner-dl" v-show="item.status !== 'recall'">
                            <div class="owner-dt">
                                <img v-if="item.PhotoUrl" :src="item.PhotoUrl" alt="" class="avatar">
                                <img v-else src="@/assets/person-avatar.png" alt="" class="avatar">
                            </div>
                        </div>
                        <!-- 撤回消息 -->
                        <div v-if="item.status == 'recall'" class="recallMsg">{{item.msg}}</div>
                        <div v-if="item.status == 'recall'" class="recallMsg">{{renderTime(item.time)}}</div>
                        <!-- 撤回消息 end -->
                        <span class="message-item-content" style="user-select: none">
                            <!-- <el-dropdown v-else @command="handleCommand(item)" trigger="click" :style="{'float':item.bySelf ? 'right':'left'}"><span class="el-dropdown-link">-->
                            <!-- 图片消息 -->
                            <img :key="item.msg" :src="item.msg?item.msg:''" v-if="item.type === 'img'" class="img-style" @load="scrollBottom" />
                            <!-- 文件card -->
                            <div v-else-if="item.type==='file'" class="file-style">
                                <el-card body-style="padding:10px">
                                    <h2>文件</h2>
                                    <h3>{{item.filename}}</h3>
                                    <div class="bottom clearfix">
                                        <span>{{readablizeBytes(item.file_length)}}</span>
                                        <a :href="item.msg" :download="item.filename">点击下载</a>
                                    </div>
                                </el-card>
                            </div>
                            <!-- 音频消息 -->
                            <div class="media-box" v-else-if="item.type==='audio'">
                                <audio :src="item.msg" controls></audio>
                            </div>
                            <!-- 视频消息 -->
                            <div class="media-box" v-else-if="item.type==='video'">
                                <video :src="item.msg" controls></video>
                            </div>
                            <!-- 工程师投标消息 -->
                            <section v-else-if="item.ext && item.ext.chat_sp_type==10001">
                                <div class="tender-box">
                                    <li class="bold2">{{item.DisplayName}}</li>
                                    <li>{{JSON.parse(item.msg).RoleName || `${JSON.parse(item.msg).WorkingYears || 0}年`}} | 距离工单地址{{JSON.parse(item.msg).Distance}}km</li>
                                    <li>擅长：{{JSON.parse(item.msg).GoodAtProducts}}</li>
                                    <li>擅长：{{JSON.parse(item.msg).GoodAtBrand}}</li>
                                    <li>解决方案: <span>{{JSON.parse(item.msg).solution}}</span></li>
                                    <li class="bold">
                                      项目报价: <span class="price">￥{{JSON.parse(item.msg).price | formatPrice}}</span>
                                    </li>
                                    <div class="item">
                                        <span class="more" v-if="!item.bySelf" @click="tenderDetail(item)">更多>></span>
                                    </div>
                                </div>
                            </section>
                            <!-- 邀请投标消息 -->
                            <section v-else-if="item.ext && item.ext.chat_sp_type==10002">
                                <div class="tender-box ">
                                    <li class="bold2">{{JSON.parse(item.msg).JobTitle}}</li>
                                    <li>{{JSON.parse(item.msg).JobAddress}}</li>
                                    <li>{{JSON.parse(item.msg).JobDomain}}</li>
                                    <li>{{JSON.parse(item.msg).JobWorkTime}}</li>
                                    <li>{{JSON.parse(item.msg).JobBudget}}</li>
                                    <div class="item">
                                        <span class="more"  @click="tenderDetail(item)">更多>></span>
                                    </div>
                                </div>
                            </section>
                            <!-- 在详情中与客服聊天-->
                            <section v-else-if="item.ext && item.ext.chat_sp_type==10003">
                                <div class="service-box">
                                    <img :src="JSON.parse(item.msg).ServiceType" alt="" class="service-box-icon">
                                    <div>
                                      <li class="bold2">{{JSON.parse(item.msg).JobTitle}}</li>
                                      <li>{{JSON.parse(item.msg).JobNo}}</li>
                                    </div>
                                </div>
                            </section>
                            <p v-else v-html="renderTxt(item.msg)" class="msg" /> 
                            <div v-if="(msgList[i-1] ? (msgList[i-1].ext  && msgList[i-1].ext.chat_sp_type==10001) : '') && item.type == 'text' " class="order-tips">
                                线下交易有误工风险！<br />交易走平台有发票，并为工程师和服务现场提供三重保险！
                            </div>
                        </span>
                        <div v-if="item.status !== 'recall'" class="time-style">{{renderTime(item.time)}}</div>
                    </div>
                </div>
                 <!-- 页面布局：三：底部 发送消息区 -->
                 <!-- {{jobInfo}} --- isShowChartButton -->
                <div class="messagebox-footer" :class="!isShowChartButton ? 'nothing-footer' : ''" v-if="(jobInfo && jobInfo.EaseMobImGroupStatus==1) || activedKey[type].IsAvailable">
                    <p class="nothing">等待{{isShowChartButtonText}}投标后即可开启聊天</p>
                    <div class="footer-icon">
                        <!-- 表情组件 -->
                        <ChatEmoji v-on:selectEmoji="selectEmoji" :inpMessage="message" />
                        <!-- 上传图片组件 -->
                        <UpLoadImage :type="this.type" :chatId="activedKey[type]" />
                        <!-- 上传文件组件 -->
                        <UpLoadFile :type="this.type" :chatId="activedKey[type]" />

                        <!-- 发送语音 -->
                        <!-- <RecordAudio v-show="isHttps" /> -->
                        <i class="el-icon-video-camera icon" @click="callVideo" :style="nowIsVideo?'pointer-events: none':'cursor: pointer'"></i>
                        <i class="el-icon-microphone icon" @click="callVoice" v-show="type == 'contact'" :style="nowIsVideo?'pointer-events: none':'cursor: pointer'"></i>
                    </div>
                    <div class="footer-send">
                        <textarea ref="txtDom" v-model="message" class="textarea" placeholder="消息" @keydown.enter="keydown"></textarea>
                        <div class="btn-box">
                            <button class="btn-send" @click="onSendTextMsg">发送</button>
                        </div>
                    </div>
                </div>
            </el-main>
            <el-aside width="240px" class="messagebox-aside" v-show="type!='contact'">
                <!-- 页面布局：右一：工单信息区 -->
                <div class="order-info-box" v-if="jobInfo">
                    <h4 class="info-title">工单信息</h4>
                    <div class="label">产品信息</div>
                    <div class="value" v-for="(item,index) in jobInfo.ProductStrs" :key="index">
                        {{item}}
                    </div>
                    <div class="label">预计服务时间</div>
                    <div class="value">{{jobInfo.EstimateExecuteDtStartStr}} 至 {{jobInfo.EstimateExecuteDtEndStr}}</div>
                    <div class="label">故障现象及需求描述</div>
                    <div class="value">{{jobInfo.JobDescription}}</div>
                </div>
                <!-- 页面布局：右二：群成员区 -->
                <GetGroupInfo ref="groupInfoModel" @closeGroupMessage="closeGroupMessage" />
            </el-aside>
        </el-container>

        <EmediaModal ref="emediaModal" @changeIsVideoState="changeIsVideoState" />
        <MultiAVModal :to="activedKey[type]" />
        <AddAVMemberModal ref="addAvMembertModal" :to="activedKey[type]" />
        <!-- 下面三个是电话沟通 、 查看报价 、 查看简历 的弹框 -->
        <!-- <call-dialog :show="showCall" @close="showCall=false" :phone="phone" ></call-dialog>
        <gk-dialog :title="isCompanyResume?'服务站的简历':'工程师的简历'" class="resume-dialog" width="800px" :show="isShowResume" @close="isShowResume=false">
          <company-resume v-show="isCompanyResume" ref="companyResume"></company-resume>
          <engineer-resume v-show="!isCompanyResume" ref="engineerResume"></engineer-resume>
        </gk-dialog>
        <offer-dialog ref="offer" :title="`${selectMess.NickName || resetName(selectMess.name) || ''}的报价`" :show="isShowOffer" @close="isShowOffer=false"></offer-dialog> -->
    </el-container>
</template>


<script>
import ChatEmoji from "../chatEmoji/index.vue";
import UpLoadImage from "../upLoadImage/index.vue";
import UpLoadFile from "../upLoadFile/index.vue";
// import RecordAudio from "../recorder/index.vue";
import { mapActions, mapGetters,mapState } from "vuex";
import EmediaModal from "../emediaModal/index";
import AddAVMemberModal from "../emediaModal/addAVMemberModal";
import MultiAVModal from "../emediaModal/multiAVModal";
import GetGroupInfo from "../group/groupInfo.vue";
import {IsRedirectBpoApplyOrder, IsShowChatButton, ChangGroupInfo} from '@/service/webImApi.js';
// import callDialog from '@/components/callDialog.vue'
// import gkDialog from '@/components/gkDialog.vue'
// import companyResume from '@/components/companyResume.vue'
// import engineerResume from '@/components/engineerResume.vue'
// import offerDialog from '@/components/offerDialog.vue'
import { getStorageAdminUser } from '@/utils/store'

export default {
  components: {
    EmediaModal,
    AddAVMemberModal,
    ChatEmoji,
    UpLoadImage,
    UpLoadFile,
    MultiAVModal,
    GetGroupInfo,
    // callDialog,
    // gkDialog,
    // companyResume,
    // engineerResume,
    // offerDialog,
    // RecordAudio
  },
  data() {
    return {
      activedKey: {
        contact: "",
        group: "",
        chatroom: ""
      },
      message: "",
      isHttps: window.location.protocol === "https:",
      loadText: "加载更多",
      status: {
        sending: "发送中",
        sent: "已发送",
        read: "已读"
      },
      nowIsVideo: false,
      isLoading:false,
      // selectMess: JSON.parse(localStorage.getItem('selectMess') || {}) 
      isShowChartButton: true,
      isShowChartButtonText: '',
      showCall:false,//
      phone:'',//聊天对象的手机号
      isShowResume:false,//显示简历
      isCompanyResume:false,//是否企业简历
      isShowOffer:false,//是否显示报价
      userInfo: getStorageAdminUser(),
    };
  },
  props: [
    "type", // 聊天类型 contact, group, chatroom
    "username", // 选中的聊天对象
    "broken", // 是否适应移动端
    "showUserList",
    "hideUserList",
    "selectMess"
  ],
  computed: {
    ...mapGetters({
      contact: "onGetContactUserList",
      group: "onGetGroupUserList",
      chatroom: "onGetChatroomUserList",
      msgList: "onGetCurrentChatObjMsg",
    }),
    ...mapState({
      chatId:state=>state.chatId,
      jobInfo:state=>state.group.jobInfo,
      cPageType:state=>state.chat.cPageType,
      cPageItem:state=>state.chat.cPageItem
    }),
    userList() {
      return {
        contact: this.contact,
        group: this.group,
        chatroom: this.chatroom
      };
    },
    hxIsLogin(){
      return this.$store.state.hxIsLogin;
    },
   
    hasService() {
      return (this.selectMess.NickName || this.resetName(this.selectMess.name) ).indexOf('客服') !== -1
    }
  },
  watch: {
    msgList: {
      handler(value,old) {
        //  console.log("获取当前聊天对象的记录",value);
          this.scrollBottom();
        //   this.isShowChartButton = true;
        //   value.map(item =>{
        //     if(item.ext && item.ext.chat_sp_type==10001) {
        //       console.log("item msg", JSON.parse(item.msg).jobNo);
        //       this.IsShowChatButtonFun(JSON.parse(item.msg).jobNo);
        //     }
        //   })
      },  
      deep: true
    },
    contact:{
      //投标私聊，获取聊天人列表时修改昵称
      handler(value){
        // console.log("获取聊天人列表时修改昵称",value);
        // for (let i = 0; i < value.length; i++) {
        //   if(value[i].name==this.activedKey[this.type].name && this.type=='contact'){
        //     this.activedKey[this.type]['NickName']=value[i].NickName
        //     this.activedKey[this.type]['IsAvailable']=value[i].IsAvailable
        //   }
        // }
      },
      deep:true
    },
    chatId(value,old){
      if(value && value!=old && this.msgList.length<10){
        this.loadMoreMsgs();
      }
    },
    type(value){
      console.log("点击事件 获取用户的信息",value);
      this.getCurrentMsg();
    },
  },
  mounted() {
    this.$refs.groupInfoModel.chengeInfoModel();
  },
  methods: {
    ...mapActions([
      "onGetCurrentChatObjMsg",
      "onSendText",
      "onCallVideo",
      "onCallVoice",
      "getGroupMembers",
      "getHistoryMessage",
      "onAddBlack",
      "onDelteFirend",
      "onGetGroupinfo",
      "recallMessage",
      "onGetGroupBlack",
      "onSetMessageRead"
    ]),
    //去掉群名称前缀
    resetName(value){
      let str='';
      if(value){
        let arr=value.split('-');
        if(arr.length > 1) {
          arr.splice(0,1);
          str=arr.join('-');
        }else {
          return value
        }
      }
      return str;
    },
    getKey(item, type) {
      let key = "";
      switch (type) {
        case "contact":
          key = item.name;
          break;
        case "group":
          key = item.groupid;
          break;
        case "chatroom":
          key = item.id;
          break;
        default:
          break;
      }
      return key;
    },
    getCurrentMsg() {
      this.onGetCurrentChatObjMsg({
        type: this.type,
        // id: "qa-temp_vuj7xt"
        id: this.chatId,
      });
    },
    select(key) {
      this.$data.activedKey[this.type] = key;
      console.log("%c 点击了左侧的tab 调select接口",'background-color:red',key,"this.$data.activedKey",this.$data.activedKey,"this.msgList",this.msgList);

      if(this.$query('chatType')) {
        this.getHistoryMessage({ name: key.name, isGroup: false });
      }
      const me = this;
      me.$data.loadText = "加载更多";
      if (this.type === "group") {
        this.$store.commit('setChatId', key.groupid);
        this.$store.commit('setChatType', this.type);
        this.onGetCurrentChatObjMsg({ type: this.type, id: key.groupid });

        setTimeout(() => {
          this.$store.commit("updateMessageStatus", {
            action: "oneUserReadMsgs",
            readUser: key.groupid
          });
          this.$forceUpdate();
        }, 100);

        if (!this.msgList) {
          this.getHistoryMessage({ name: key.groupid, isGroup: true });
        }
      } else if (this.type === "contact") {
        this.$store.commit('setChatId', key.name);
        this.$store.commit('setChatType', this.type);
        this.onGetCurrentChatObjMsg({ type: this.type, id: key.name });
        // this.onGetCurrentChatObjMsg({ type: this.type, id: "qa-temp_vuj7xt" });
        setTimeout(() => {
          this.$store.commit("updateMessageStatus", {
            action: "oneUserReadMsgs",
            // readUser: "qa-temp_vuj7xt",
            readUser: key.name
          });
          this.$forceUpdate();
        }, 100);

        if (!this.msgList) {
          this.getHistoryMessage({ name: key.name, isGroup: false });
          // this.getHistoryMessage({ name: "qa-temp_vuj7xt", isGroup: false });
        }
      } else if (this.type === "chatroom") {
        const me = this;
        // me.roomId = key.id

        this.$store.commit('setChatId', key.id);
        this.$store.commit('setChatType', this.type);
        this.onGetCurrentChatObjMsg({ type: this.type, id: key.id });

        this.$IM.conn.joinChatRoom({
          roomId: key.id, // 聊天室id
          success: function() {
            // console.log("加入聊天室成功");
            if (!me.msgList) {
              me.getHistoryMessage({ name: key.id, isGroup: true });
              setTimeout(() => {
                me.$forceUpdate();
              }, 100);
            }
          }
        });
      }
    },
    IsShowChatButtonFun(JobNo) {
       // 默认是true 但是若是后台返回的isShowChartButton为false 的话 则为隐藏输入区域
      // this.isShowChartButton = this.$data.activedKey[this.type].IsShowChartButton;
      let ToUserCode = "";
      if (this.type === "contact") {
        ToUserCode = this.$data.activedKey[this.type].name;
      } else if (this.type === "group") {
        ToUserCode = this.$data.activedKey[this.type].groupid;
      }
      // console.log("ToUserCode",ToUserCode,"this.userInfo.userCode,",this.userInfo.UserCode,"this.$data.activedKey",this.$data.activedKey);
      IsShowChatButton({
          platform: 'pcweb',
          JobNo: JobNo,
          IsPrivateChat: true,
          FromUserCode: this.userInfo.role_id,
          ToUserCode: ToUserCode,
        }).then(res => {
          if(res.Result == 0) {
            this.isShowChartButton = false
            this.isShowChartButtonText = {"p": '工程师', "e": "服务站"}[ToUserCode.slice(3,4)] || ''
          }
          console.log("根据返回的值 处理是否是隐藏调发送内容的按钮",res);
        })
    },
    //查看历史消息
    loadMoreMsgs() {
      this.isLoading=true;
      const me = this;
      const success = function(msgs) {
        if (msgs.length === 0) {
          me.$data.loadText = "已无更多数据";
        }
      };
      let name = "";
      let isGroup = false;
      if (this.type === "contact") {
        name = this.$data.activedKey[this.type].name;
      } else if (this.type === "group") {
        name = this.$data.activedKey[this.type].groupid;
        isGroup = true;
      } else if (this.type === "chatroom") {
        name = this.$data.activedKey[this.type].id;
        isGroup = true;
      }
      this.getHistoryMessage({
        // name: "qa-temp_vuj7xt",
        name,
        isGroup,
        success
      });
    },
    //切换聊天对象
    changeMenus() {
      if (this.type === "contact") {
        console.log('contact')
      } else if (this.type === "group") {
        this.$refs.groupInfoModel.chengeInfoModel();
        this.getGroupInfo();
      }
    },
    menuClick(i) {
      this.changeMenus();
      switch (i) {
        case "1":
          // console.log("加入黑名单");
          this.onAddBlack({
            userId: this.$data.activedKey[this.type]
          });
          this.$data.activedKey.contact = "";
          break;
        case "2":
          this.onDelteFirend({
            userId: this.$data.activedKey[this.type],
            callback: () => {
              this.closeContactMessage();
            }
          });
          break;
        default:
          break;
      }
    },
    getGroupInfo() {
      this.onGetGroupinfo({
        select_id: this.$data.activedKey[this.type].groupid
      });
    },
    keydown(event) {
      event.preventDefault(); // 阻止浏览器默认换行操作
      this.onSendTextMsg();
      return false
    },
    onSendTextMsg() {
      if (this.$data.message == "" || this.$data.message == "\n") {
        this.$data.message = "";
        return;
      }
      this.onSendText({
        chatType: this.type,
        chatId: this.$data.activedKey[this.type],
        message: this.$data.message
      });
      this.$data.message = "";
      this.onSetMessageReadFun()
    },
    onSetMessageReadFun() {
      this.onSetMessageRead({
        chatId: this.$data.activedKey[this.type],
        chatType: this.type,
      });
      // this.$store.dispatch('getSessionList', '')
    },
    selectEmoji(v) {
      this.$data.message = v;
      this.$refs.txtDom.focus();
    },

    //渲染表情图片
    customEmoji(value) {
      var str='';
      Object.keys(this.$IM.Emoji.map).map((item,index)=>{
        if(item==value){
          let url=this.$IM.Emoji.imgs[index].path;
          str=`<img src="${url}" style="width:20px"/>`
        }
      })
      return str;
    },
    //渲染消息文字和表情图片
    renderTxt(txt = "") {
      let rnTxt = [];
      let match = null;
      const regex = /(\[.*?\])/g;
      let start = 0;
      let index = 0;
      while ((match = regex.exec(txt))) {
        index = match.index;
        if (index > start) {
          rnTxt.push(txt.substring(start, index));
        }
        if (match[1] in this.$IM.Emoji.map) {
          // const v = this.$IM.Emoji.map[match[1]];
          rnTxt.push(this.customEmoji(match[1]));
        } else {
          rnTxt.push(match[1]);
        }
        start = index + match[1].length;
      }
      rnTxt.push(txt.substring(start, txt.length));
      return rnTxt.join('');//.replace(/,/g, "")
    },

    callVideo() {
      console.log("888888 type",this.type);
      if (this.type == "contact") {
        this.$refs.emediaModal.showEmediaModal();
        this.$refs.emediaModal.showCallerWait(
          this.cPageItem.NickName || this.resetName(this.cPageItem.name)
        );
        const videoSetting = JSON.parse(localStorage.getItem("videoSetting"));
        const recMerge = (videoSetting && videoSetting.recMerge) || false;
        const rec = (videoSetting && videoSetting.rec) || false;
        this.onCallVideo({
          chatType: this.type,
          to: this.$data.activedKey[this.type].name,
          rec,
          recMerge
        });
      } else if (this.type == "group") {
        this.getGroupMembers(this.chatId);
        this.$refs.addAvMembertModal.show();
      }
    },
    callVoice() {
      this.$refs.emediaModal.showEmediaModal();
      this.$refs.emediaModal.showCallerWait(
        this.cPageItem.NickName || this.resetName(this.cPageItem.name)
      );
      const videoSetting = JSON.parse(localStorage.getItem("videoSetting"));
      const recMerge = (videoSetting && videoSetting.recMerge) || false;
      const rec = (videoSetting && videoSetting.rec) || false;
      this.onCallVoice({
        chatType: this.type,
        to: this.$data.activedKey[this.type].name,
        rec,
        recMerge
      });
    },
    readablizeBytes(value) {
      let s = ["Bytes", "KB", "MB", "GB", "TB", "PB"];
      let e = Math.floor(Math.log(value) / Math.log(1024));
      return (value / Math.pow(1024, Math.floor(e))).toFixed(2) + " " + s[e];
    },

    // TODO 可以抽离到utils
    renderTime(time) {
      let nowStr = new Date();
      let localStr = time ? new Date(time) : nowStr;
      let localMoment ='';
      if(this.$formatTime(localStr,'yyy-MM-dd')==this.$formatTime(nowStr,'yyy-MM-dd')){
        localMoment = this.$formatTime(localStr,'hh:mm');
      }else{
        localMoment = this.$formatTime(localStr,'MM/dd hh:mm');
      }
      return localMoment;
    },
    getLastMsg(item) {
      let name=this.$store.state.chatType;
      const chatList = this.$store.state.chat.msgList[name];
      let userId = "";
      if (name == "contact") {
        userId = item.name;
      } else if (name == "group") {
        userId = item.groupid;
      } else {
        userId = item.id;
      }
      const currentMsgs = chatList[userId] || [];
      const lastMsg = currentMsgs.length
        ? currentMsgs[currentMsgs.length - 1].msg
        : "";
      const msgTime = currentMsgs.length
        ? this.renderTime(currentMsgs[currentMsgs.length - 1].time)
        : "";
      return { lastMsg, msgTime };
    },
    scrollBottom() {
      this.isLoading=true;
      setTimeout(() => {
        const dom = this.$refs.msgContent;
        if (!dom) return;
        dom.scrollTop = dom.scrollHeight;
      }, 0);
    },
    handleCommand(item) {
      let name = "";
      if (this.type === "contact") {
        name = this.$data.activedKey[this.type].name;
      } else if (this.type === "group") {
        name = this.$data.activedKey[this.type].groupid;
      } else if (this.type === "chatroom") {
        name = this.$data.activedKey[this.type].id;
      }
      this.recallMessage({ to: name, message: item });
    },
    closeGroupMessage() {
      //退出群组或解散群组时关闭聊天框
      this.$data.activedKey["group"] = "";
    },
    closeContactMessage() {
      //删除好友时关闭当前聊天框
      this.$data.activedKey["contact"] = "";
    },
    changeIsVideoState(v) {
      v ? (this.$data.nowIsVideo = true) : (this.$data.nowIsVideo = false);
    },
    //查看投标详情
    tenderDetail(item){
      let path='';
      let obj=JSON.parse(item.msg);
      IsRedirectBpoApplyOrder({
        JobId:obj.jobApplyOrderId,
        UserCode:this.userInfo.role_id,
        platform:'pcweb'
      }).then(r=>{
        if(r.Result==1 && r.Data.IsRedirect){
          if(item.bySelf){
            path='/pickOrderInfo';
          }else{
            path='/createOrderProcess/bidder';
          }
          this.$router.push({
            path,
            query:{
              jobNo:obj.jobNo,
            }
          })
        }else{
          this.$toast(r.Message);
        }
      })
    },
    changGroupInfoFun() {
      this.$prompt("群组名", "修改群信息", { confirmButtonText: "修改", cancelButtonText: "取消"})
        .then(({ value }) => {
          ChangGroupInfo({
            group_id: this.cPageItem.groupid,
            groupname: value,
            ManageUserId: this.userInfo.role_id,
            maxusers: 200
          }).then(res=>{
            if(res.Result == 1) {
              this.$message({
                type: "success",
                message: "修改成功"
              });
            }else {
              this.$message({
                type: "error",
                message: "修改失败"
              });
            }
          })
        })
        .catch(() => {});
    },
    //查看简历
    lookResume(){
      let userCode=this.selectMess.name.split('-')[1];
      if(userCode){
        let code=userCode.substr(1);
        if(userCode.indexOf('p')==0){
          this.isCompanyResume=false;
          this.$refs.engineerResume.GetBasicInfo(code);
        }else if(userCode.indexOf('e')==0){
          this.isCompanyResume=true;
          this.$refs.companyResume.GetBasicInfo(code);
        }
        this.isShowResume=true;
      }
    },
    //查看报价
    lookOffer(){
      let obj=null;
      for (let i = 0; i < this.msgList.length; i++) {
        if(!this.msgList[i].bySelf && this.msgList[i].ext && this.msgList[i].ext.chat_sp_type==10001){
          obj=JSON.parse(this.msgList[i].msg)
        }
      }
      if(obj && obj.jobApplyOrderId){
        this.$refs.offer.pageInit(obj.jobApplyOrderId);
        this.isShowOffer=true;
      }else{
        this.$toast('您的聊天记录没有工单信息');
      }
    },
    takeCall(){
      this.phone=this.selectMess.FriendHandSet;
      if(this.phone){
        this.showCall=true;
      }else{
        this.$toast('没有对方联系方式');
      }
    },
  },
};
</script>

<style scoped lang='scss'>
.messagebox {
  width: 100%;
  height: 100%;
  position: relative;
  .messagebox-header {
    border-bottom: 1px solid #d6dce0;
    box-sizing: border-box;
    height: 60px;
    line-height: 60px;
    padding: 0 16px;
    background: #fff;
    .name{
      font-size: 16px;
      color: #333;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    button {
      float: right;
      height: 30px;
      line-height: 30px;
      margin: 15px 10px;
      padding: 0 10px;
      border-radius: 3px;
    }
  }
  .el-container{
    height: 100px;
  }
  .messagebox-main{
    display: flex;
    flex-direction: column;
    padding: 0;
    position: relative;
    overflow: hidden;
  }
  .messagebox-content {
    height: 100px;
    flex: 1;
    top: 50px;
    background: #fff;
    padding: 10px 16px;
    overflow-y: auto;
    overflow-x: auto;
    .more-msgs {
      border-radius: 8px;
      cursor: pointer;
      width: 100px;
      text-align: center;
      margin: 0 auto;
      font-size: 12px;
      color: #409eff;
      cursor: pointer;
    }
  }
}
.owner-dl{
  overflow: hidden;
  display: contents;
  .owner-dt{
    width: 24px;
    height: 24px;
    float: left;
    margin-right: 10px;
  }
  .avatar{
    width: 100%;
    height: 100%;
    border-radius: 50%;
    display: block;
  }
  .owner-dd{
    float: left;
    font-size: 14px;
    color: #333;
    line-height: 24px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  &~ .msg-content{
    margin-left: 34px;
  }
  &~.time-style{
    margin-left: 34px;
  }
}
.messagebox-footer {
    border-top: 1px solid #e5e5e5;
    width: 100%;
    height: 160px;
    // position: absolute;
    // bottom:0;
    color:#333;
    background-color: #fff;
    .footer-icon {
        padding: 10px 10px;
        text-align: left;
        display: flex;
        [class^=el-icon] {
            font-size: 20px;
        }
        .icon {
            color: #999;
            font-size: 20px;
            margin-left: 8px;
        }
    }
    .footer-send {
        height: 100px;
        width: 100%;
        .textarea {
            text-align: left;
            height: 60px;
            width: 100%;
            box-sizing: border-box;
            bottom: 5px;
            font-size: 14px;
            padding-left: 10px;
            border: 1px solid #fff;
            outline: none;
            resize: none;
        }
        .btn-box {
            text-align: right;
            padding: 5px;
        }
        .btn-send,.btn-default {
            width: 100px;
            height: 30px;
            text-align: center;
            line-height: 30px;
            color: #fff;
            background-color: #f75959;
            border: 0;
            border-radius: 2px;
            outline: 0;
        }
    }
    .nothing {
        display: none;
    }
    &.nothing-footer {
      display: flex;
      align-items: center;
      justify-content: center;
      .nothing {
        display: block;
        position: absolute;
        font-size: 20px;
        color: #666;
      }
      &::before {
      content: '';
      position: absolute;
      width: 100%;
      height: 160px;
      background: #f4f4f4;
    }
  }
}

.messagebox-aside {
  height:100%;
  border-left: 1px solid #e5e5e5;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  .order-info-box {
    padding: 10px 18px;
    height: 250px;
    border-bottom: 1px solid #e5e5e5;
    overflow: hidden;
    overflow-y: auto;
    .info-title {
      font-size: 16px;
      color: #333;
      font-weight: bold;
      line-height: 2;
    }
    .label {
      font-size: 14px;
      color: #333;
      line-height: 24px;
      margin-bottom: 6px;
    }
    .value {
      font-size: 14px;
      color: #999;
      line-height: 24px;
    }
  }
  .member-wrapper{
    flex: 1;
    height: 200px;
  }
}
.message-group {
  padding-top: 10px;
  font-size: 14px;
  line-height: 1.5;
  clear: both;
  width: 100%;
  .message-item-content{
    display: flow-root;
    margin-bottom: 10px;
  }
  &.self{
    .owner-dt{
      float: right;
      margin-right: 0px;
    }
    .owner-dd{
      display: none;
    }
    .message-item-content{
      // float: right;
      text-align: right;
    }
    .msg {
      float: right;
      border-radius: 4px 0px 4px 4px;
    }
    .time-style{
      text-align: right;
    }
    .owner-dt {
      margin-left: 10px;
    }
    .msg {
      color: #fff;
      background-color: rgba(247, 89, 89, .8);
    }
    .tender-box  {
      text-align: left;
    }
    .service-box {
       text-align: left;
    }
    .order-tips {
      margin-top: 45px;
    }
  }
  .msg {
    list-style: none;
    background-color: rgba(249, 249, 249, 1);
    text-align: left;
    padding: 2px 10px;
    border-radius:0px 4px 4px;
    display: inline-block;
    word-break: break-all;
    color: #666;
    font-size: 14px;
    line-height: 1.5;
    margin: 0;
  }
  .recall-msg {
    font-size: 12px;
    color: #999;
    width: 100%;
    text-align: center;
  }
  .status {
    display: inline;
    position: relative;
    top: 20px;
    font-size: 12px;
    left: -6px;
    color: #666;
    float: left;
  }
  .unread-num {
    float: left;
    width: 100%;
  }
  .icon-style {
    display: inline-block;
    background-color: #f04134;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    color: white;
    line-height: 1.5;
    text-align: center;
  }
  .emoji-style {
    width: 22px;
    float: left;
  }
  .img-style {
    max-width: 350px;
    display: inline-block;
  }
  .time-style {
    clear: both;
    margin-left: 2px;
    margin-top: 3px;
    font-size: 12px;
    color: #ccc;
  }
  .file-style {
    display: inline-block;
    width: 240px;
    margin: 0px 2px 2px 0;
    font-size: 13px;
    h2 {
      border-bottom: 1px solid #e0e0e0;
      font-weight: 400;
      text-align: left;
      font-size: 16px;
      line-height: 24px;
      padding-bottom: 6px;
    }
    h3 {
      max-width: 100%;
      font-size: 15px;
      line-height: 24px;
      font-weight: 600;
      // -o-text-overflow: ellipsis;
      // text-overflow: ellipsis;
      // overflow: hidden;
      // white-space: nowrap;
      word-break: break-all;
      text-align: left;
      margin-top: 6px;
      margin-bottom: 20px;
    }
    .bottom {
      span {
        color: #999999;
        text-align: left;
        padding-right: 6px;
      }
    }
    a {
      color: #999999;
      float: right;
      text-decoration: none;
      &:hover{
        color: #f75959;
      }
    }
    .el-dropdown-link {
      cursor: pointer;
      color: #409eff;
    }
    .el-icon-arrow-down {
      font-size: 12px;
    }
  }
  .media-box{
    display: inline-block;
    max-width: 100%;
    audio{
      width: 300px;
    }
    video{
      width: 400px;
    }
  }
  .tender-box{
    border-radius: 4px;
    border: 1px solid #e5e5e5;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    background-color: #fff;
    padding: 10px;
    width: 400px;
    display: inline-block;
    li {
      color: #666;
      font-size: 15px;
      line-height: 1.8;
      &.bold,&.bold2 {
        font-weight: bold;
        color: #333;
        .price{
          color: #f75959;
          font-weight: bold;
        }
      }
      &.bold2 {
        font-size: 16px;
      }
      
    }
    .item{
      overflow: hidden;
    }
    .label{
      float: left;
      font-size: 14px;
      color: #333;
      line-height: 24px;
      margin-right: 10px;
    }
    .desc{
      font-size: 14px;
      color: #999;
      line-height: 24px;
      word-break: break-all;
      float: left;
    }
    .more{
      color: #999999;
      float: right;
      text-decoration: none;
      &:hover{
        color: #f75959;
      }
    }
  }
  .service-box {
      border-radius: 15px;
      border: 1px solid #e5e5e5;
      box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
      background-color: #fff;
      padding: 15px;
      width: 400px;
      display: inline-block;
      .service-box-icon {
        width: 80px;
        height: 80px;
        float: left;
        border-radius: 3px;
      }
      li {
        padding-left: 95px;
        color: #666;
        font-size: 15px;
        line-height: 1.8;
        &.bold2 {
          font-size: 16px;
          height: 55px;
          font-weight: bold;
          color: #333;
        }
      }
    }
  .order-tips {
    width: 60%;
    position: sticky;
    margin: 20px auto;
    padding: 5px;
    background-color: #eeeeee;
    text-align: center;
    color: #f75959;
    border-radius: 5px;
  }
}

</style>
<style lang="scss">
.resume-dialog{
  .dialog-body{
    height: 80vh;
    overflow-y: auto;
  }
}
.btn-primary {
  background-color: #f75959;
  color: #fff;
  &:hover {
    background-color: #ff3838;
  }
}
button, input, select {
  outline: none;
  border: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
</style>

